module.exports = __webpack_public_path__ + "static/media/arrow-results.d1e2f4b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nxbus/arrow-results.svg
// module id = 272
// module chunks = 0